// opening/closing elements i.e accordions / dropdowns
(function () {
  const togglers = [...document.querySelectorAll("[data-expander-toggle]")];

  if (togglers.length !== 0) {
    togglers.forEach((toggler) => {
      const toggleAttributeValue = toggler.getAttribute("data-expander-toggle");
      const toggleTarget = document.getElementById(toggleAttributeValue);

      toggler.addEventListener("click", (e) => {
        if (!toggler.classList.contains("active")) {
          closeOthers();
          toggler.classList.add("active");
          toggler.setAttribute("aria-expanded", "true");

          if (toggleTarget) {
            toggleTarget.classList.add("active");
          }
        } else if (toggler.classList.contains("active")) {
          toggler.classList.remove("active");
          toggler.setAttribute("aria-expanded", "false");
          if (toggleTarget) {
            toggleTarget.classList.remove("active");
          }
        }
      });

      if (toggleTarget) {
        toggleTarget.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            toggler.classList.remove("active");
            toggler.setAttribute("aria-expanded", "false");
            toggler.focus();
            toggleTarget.classList.remove("active");
          }
        });
      }
    });
    function closeOthers() {
      togglers.forEach((toggler) => {
        if (toggler.hasAttribute("data-close-all")) {
          const toggleAttributeValue = toggler.getAttribute(
            "data-expander-toggle"
          );
          const toggleTarget = document.getElementById(toggleAttributeValue);
          toggler.classList.remove("active");
          toggler.setAttribute("aria-expanded", "true");

          if (toggleTarget) {
            toggleTarget.classList.remove("active");
          }
        }
      });
    }
  }
})();

// predictive search result link items have tabindex -1 for some reason - this function removes that attribute so that they can then be accessed via keyboards.
(function () {
  const searchButton = document.querySelector(".search__button");

  if (searchButton) {
    searchButton.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        const resultItems = [
          ...document.querySelectorAll(".predictive-search__item.link"),
        ];

        if (resultItems.length !== 0) {
          resultItems.forEach((resultItem) => {
            resultItem.setAttribute("tabindex", "0");
          });
        }
      }
    });
  }
})();

// use observers to watch for when the results pop up and then announce that it's open. when it's tabbed, esc to close out.

(function () {
  const searchContainer = document.querySelector(
    "[data-search-results='desktop']"
  );
  const announcerText = document.querySelector(
    '[data-smartsearch-announcer="desktop"]'
  );
  const inputElment = document.querySelector('[data-searcher1="desktop"]');

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      announcerText.innerHTML = "";
      announcerText.innerHTML = "results available on the next tab";

      searchContainer.addEventListener("keydown", (e) => {
        if (e.key === "Escape" || e.key === "Esc") {
          searchContainer.classList.remove("showup");
          removeChildElements();
          inputElment.focus();
        }
      });
    });
  });

  function removeChildElements() {
    while (searchContainer.firstChild) {
      searchContainer.removeChild(searchContainer.firstChild);
    }
  }
  observer.observe(searchContainer, {
    childList: true,
  });
})();
